/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { GetAllAdminName, getTargetData } from "../../apiServices";
import { useSelector } from "react-redux";
import {
  dateFormate,
  decryptedAdminID,
  messages,
  sadMessage,
  months,
} from "../../utility";
import styles from "./Style.module.scss";

import Runningimage from "../../assets/images/GirlRunningBig.png";
import image from "../../assets/images/GirlRunningsmall.png";
import winnerimagesmall from "../../assets/images/GirlWinningsmall.png";
import winnerimagebig from "../../assets/images/GirlWinningbig.png";
import sadSmall from "../../assets/images/GirlSadsmall.png";
import sadBig from "../../assets/images/GirlSadbig.png";
import TargetAnalyticsFilter from "../AdminDetails/ConfigarationTablesCrud/Targetanalytics/TargetAnalyticsFilter";
import { Autocomplete, MenuItem, TextField } from "@mui/material";
import Loader from "../../components/Common/Loader/Loader";

function TargetMonthly() {
  const [targetData, setTargetData] = useState({
    tartgetAmount: 0,
    AchiveAmount: 0,
  });
  const [adminList, setAdminList] = useState([]);
  const [month, setMonth] = useState("");
  const [loading, setLoading] = useState(false);

  const mothlyTargetFilter = useSelector(
    (state) => state.CandidateDashboardFilterDetails.AdminMonthlyTarget,
  );

const adminuserName = localStorage.getItem("adminuserName")

  const getMonthDates = (monthStr) => {
    if (!monthStr) return {};

    const [monthName, year] = monthStr.split(" ");
    const monthIndex = months.indexOf(monthName);

    const startDate = new Date(year, monthIndex, 1);
    const endDate = new Date(year, monthIndex + 1, 0);

    return {
      startDate: dateFormate(startDate),
      endDate: dateFormate(endDate),
    };
  };
  const monthDates = getMonthDates(month);

  useEffect(() => {
    const now = new Date();
    const defaultMonth = `${months[now.getMonth()]} ${now.getFullYear()}`;
    setMonth(defaultMonth);
  }, []);
  const fetchData = () => {
    setLoading(true);

    const monthDates = getMonthDates(month);

    const payload = {
      adminId: decryptedAdminID() == 1 ? -1 : decryptedAdminID(),
      startDate: month
        ? monthDates.startDate
        : dateFormate(
            new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          ),
      endDate: month
        ? monthDates.endDate
        : dateFormate(
            new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
          ),
      page: 1,
    };

    getTargetData(payload)
      .then((data) => {
        const targetList = data?.result?.target ?? [];

        if (decryptedAdminID() == 1) {
          let totalTargetAmount = 0;
          let totalAchievedAmount = 0;

          targetList.forEach((el) => {
            totalTargetAmount += parseFloat(el.target_amount || 0);
            totalAchievedAmount += parseFloat(el.total_ctc || 0);
          });

          setTargetData({
            tartgetAmount: totalTargetAmount,
            AchiveAmount: totalAchievedAmount,
          });
        } else {
          const currentAdminId = Number(decryptedAdminID());

          const currentAdminTarget = targetList.find(
            (el) => el.admin_id === currentAdminId,
          );

          setTargetData({
            tartgetAmount: parseFloat(currentAdminTarget?.target_amount || 0),
            AchiveAmount: parseFloat(currentAdminTarget?.total_ctc || 0),
          });
        }
      })
      .catch(() => {
        console.log("API error");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchData();
  }, [mothlyTargetFilter, month]);

  const target = Number(targetData.tartgetAmount);
  const achieved = Number(targetData.AchiveAmount);

  const getStepValues = (target, totalBars = 7) => {
    if (!target || target <= 0) return [];

    const step = target / (totalBars - 1);

    // 👉 decide rounding unit
    let unit;
    if (target < 100000)
      unit = 1000; // 1K
    else if (target < 1000000)
      unit = 10000; // 10K
    else unit = 100000; // 1L

    const values = [];

    for (let i = 0; i < totalBars; i++) {
      let val = step * i;

      // 👉 round properly
      val = Math.round(val / unit) * unit;

      values.push(val);
    }

    // ✅ fix first & last strictly
    values[0] = 0;
    values[totalBars - 1] = target;

    // ✅ ensure increasing (no duplicates)
    for (let i = 1; i < values.length; i++) {
      if (values[i] <= values[i - 1]) {
        values[i] = values[i - 1] + unit;
      }
    }

    // ✅ again fix last (important)
    values[totalBars - 1] = target;

    return values;
  };
  const values = getStepValues(target);

  const getCurrentIndex = (values, achieved) => {
    for (let i = 0; i < values.length - 1; i++) {
      if (achieved >= values[i] && achieved < values[i + 1]) {
        return i;
      }
    }
    return values.length - 1;
  };

  const currentIndex = getCurrentIndex(values, achieved);

  /* ✅ REAL POSITION BASED ON % */
  // const percentage = target ? Math.min(achieved / target, 1) : 0;
  const percentage =
  target > 0 ? Math.min(Math.max(achieved / target, 0), 1) : 0;
console.log(percentage," percentage");

const today = new Date();

const selectedEndDate = month
  ? new Date(monthDates.endDate)
  : new Date();

// 👉 normalize dates (remove time issue)
today.setHours(0, 0, 0, 0);
selectedEndDate.setHours(0, 0, 0, 0);

// 👉 checks
const isPastMonth = selectedEndDate < today;
const isCurrentMonth =
  today.getMonth() === selectedEndDate.getMonth() &&
  today.getFullYear() === selectedEndDate.getFullYear();

const isCompleted = target > 0 && achieved >= target;

// ✅ FINAL RULE
const isSad = isPastMonth && !isCompleted;

  const defaultColors = [
    "#FC4646",
    "#FC4646",
    "#EC8E14",
    "#EC8E14",
    "#EC8E14",
    "#0D8E45",
    "#0D8E45",
  ];

  const colors = values.map((val, index) => {
    if (isCompleted) return "#0D8E45";

    if (isSad) {
      return index <= currentIndex ? "#FC4646" : "#ccc";
    }

    return defaultColors[index];
  });
  const safeMessages = Array.isArray(messages) ? messages : [];

  const currentMessage = isSad
    ? sadMessage
    : safeMessages[Math.min(currentIndex, safeMessages.length - 1)] || {
        title: "",
        text: "",
      };
  const isNoData = target === 0 && achieved === 0;
  const progressShow = target === 0 ;

  return (
    <>
      {loading && <Loader open={loading} fullScreen />}
      <div className={styles.Maincontainer}>
        <div className={styles.container}>
          {/* LEFT */}
          <div className={styles.left}>
            {isNoData ? (
              <div className={styles.NoRecord}>
                <h2 style={{ fontSize: "40px" }}>📭</h2>

                <h4 style={{ color: "#666", marginTop: "10px" }}>
                  No Target Data
                </h4>

                <p
                  style={{ color: "#999", fontSize: "14px", marginTop: "5px", textAlign:"center" }}
                >
                  Super Admin not fixing target amount. <br />
                  Will be added soon.
                </p>
              </div>
            ) : (
              <>
                {" "}
                <div>
                  <h3>
                    <span>{isCompleted ? "Congrats" : "Hey"}</span>{" "}
                    <span style={{ color: isSad ? "#FC4646" : "#0D8E45" }}>
                      <b>{adminuserName}</b>
                    </span>{" "}
                    <span>{isCompleted ? "🎉" : isSad ? "😓" : ""}</span>{" "}
                  </h3>

                  <h5>{currentMessage?.title}</h5>

                  <p>{currentMessage?.text}</p>
                </div>
                <div className={styles.barWrapper}>
                  {/* GIRL */}
                  {values.length > 0 && (
                    <div
                      className={styles.girlOnBar}
                      style={{
                        left: `${((currentIndex + 0.5) / values.length) * 100}%`,
                        bottom: `${10 + currentIndex * 50 + 20}px`, // ✅ gap added
                      }}
                    >
                      <img
                        src={
                          isCompleted
                            ? winnerimagesmall
                            : isSad
                              ? sadSmall
                              : image
                        }
                        alt="image"
                      />
                    </div>
                  )}

                  {/* BARS */}
                  <div className={styles.bars}>
                    {values.map((value, index) => (
                      <div key={index} className={styles.barItem}>
                        <div
                          className={styles.bar}
                          style={{
                            height: `${10 + index * 50}px`,
                            background: colors[index],
                          }}
                        ></div>

                        <div className={styles.label}>
                          ₹{value.toLocaleString("en-IN")}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>

          {/* RIGHT */}
          <div
            className={styles.right}
            style={{
              background:"#178a45",
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div
                className={`${styles.targetTitle} `}
              >
                Target
              </div>
              <div style={{ marginBottom: "10px" }}>
                <Autocomplete
                  options={(() => {
                    const startYear = 2025;
                    const currentYear = new Date().getFullYear();
                    const items = [];

                    for (let year = startYear; year <= currentYear; year++) {
                      months.forEach((m) => {
                        items.push(`${m} ${year}`);
                      });
                    }

                    return items;
                  })()}
                  value={month}
                  disableClearable={false}
                  onChange={(event, newValue) => {
                    if (!newValue) {
                      const now = new Date();
                      setMonth(
                        `${months[now.getMonth()]} ${now.getFullYear()}`,
                      );
                    } else {
                      setMonth(newValue);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Filter Month" size="small" />
                  )}
                  sx={{
                    width: 180,

                    "& .MuiInputBase-input": {
                      color:  "#fff",
                    },

                    "& .MuiInputLabel-root": {
                      color:  "#fff",
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color:  "#fff",
                    },

                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor:  "#fff",
                      },
                      "&:hover fieldset": {
                        borderColor:  "#fff",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor:  "#fff",
                      },
                    },

                    "& .MuiSvgIcon-root": {
                      color:  "#fff",
                    },
                  }}
                />
              </div>
            </div>
            <div className={styles.rightsubContainer}>
              {isNoData ? (
                <div className={styles.NoRecord}>
                  <h3 style={{ color: "#fff" }}>No Records Found</h3>
                  <div style={{ fontSize: "50px" }}>😕</div>
                  <p style={{ color: "#bbb", fontSize: "14px" }}>
                    No target data available for this month
                  </p>
                </div>
              ) : (
                <>
                <div className={styles.progressBar}>
  <div
    className={styles.progressFill}
    style={{ width: `${percentage * 100}%` }}
  />
</div>

<div className={`${styles.amount} ${styles.runningamount
}`}>
  <span className={styles.achievedAmount}>
    ₹ {achieved.toLocaleString("en-IN")} /
  </span>
  <span className={styles.targetAmount}>
    ₹ {target.toLocaleString("en-IN")}
  </span>
</div>
                  {/* {!progressShow && (
                    <>
                      <div className={ styles.progressBar}>
                        <div
                          className={styles.progressFill}
                          style={{ width: `${percentage * 100}%` }}
                        />
                      </div>

                      <div
                        className={`${styles.amount} ${isCompleted ? styles.completeamount : isSad ? styles.sadamount : styles.runningamount}`}
                      >
                        <span className={styles.achievedAmount}>
                          ₹ {achieved.toLocaleString("en-IN")} /{" "}
                        </span>
                        <span className={styles.targetAmount}>
                          ₹ {target.toLocaleString("en-IN")}
                        </span>
                      </div>
                    </>
                  )}  */}
                  <div className={styles.rightside}>
                    <img
                      src={
                        isCompleted
                          ? winnerimagebig
                          : isSad
                            ? sadBig
                            : Runningimage
                      }
                    />
                  </div>
                </>
              )}
            </div>
            {/* <div
            className={`${styles.leftside} ${isCompleted ? styles.leftside1 : isSad ? styles.leftside2 : styles.running}`}
          >
            <img
              src={isCompleted ? winnerimagebig : isSad ? sadBig : Runningimage}
            />
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default TargetMonthly;
